const state = {
  isLogin: false,
  userToken: ''
};

const getters = {
  getUserToken(state) {
    if (!state.isLogin) {
      state.userToken = localStorage.getItem('userToken')
    }
    return localStorage.getItem('userToken')
  },
  isLogin(state) {
    if (!state.isLogin) {
      state.isLogin = localStorage.getItem('isLogin')
    }
    return localStorage.getItem('isLogin')
  }
};

const mutations = {
  userLogin(state, data) {
    localStorage.setItem('userToken', data); //把用户名和登录状态存储到 localStorage
    localStorage.setItem('isLogin', true);
    state.isLogin = true;
    state.userToken = data;
  },
  userLogout(state, data) {
    localStorage.removeItem('userToken'); //移除 localStorage
    localStorage.removeItem('isLogin');
    state.isLogin = data;
    state.userToken = '';
  }
};

const actions = {
  login({
    commit
  }, userToken) {
    commit('userLogin', userToken); // 引用 userStatus 方法，并传值
  },
  logout({
    commit
  }, status) {
    commit('userLogout', status)
  }
};

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/module/login.js